import React from 'react';
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { FormControl, FormGroup } from '@mui/material';

export default function Skillset(){

  const gemsUsed = {
    list_1: ["activeadmin", "activestorage-validator", "active_model_serializers", "acts_as_paranoid", "ckeditor", "country_select", "countries", "devise", "httparty", "icalendar", "jwt", "pagy","capistrano", "active_model_serializers","cancancan", "paranoia"],
    list_2: ["paperclip", "pg", "pry-rails", "search_cop", "select2-rails", "sweetalert-rails", "stripe", "twilio-ruby", "letter_opener", "dotenv-rails", "nested_form", "sidekiq", "json-schema", "pundit", "cocoon", "rails-i18n"]
  }

  const techSkills = [
    {
      "name": "Web Development:",
      "values": "Ruby on Rails, Next.js, Strapi js, React js, Tailwind CSS, PWA, WAI-ARIA, ASP.Net, Laravel, Bootstrap, HTML, JS, jQuery."
    },
    {
      "name": "Deployment:",
      "values": "MinIO, Netlify, Heroku, AWS EC2, S3, Capistrano."
    },
    {
      "name": "Services:",
      "values": "Mixpanel, Stripe, Paypal, Recaptcha, Twilio. Canda Post, EShipper, Altova MapForce."
    },
    {
      "name": "Databases:",
      "values": "PostgreSQL, MSSQL, MySQL, Firebase, SQLite."
    },
    {
      "name": "Version Control:",
      "values": "Git, Bitbucket, SVN."
    },
    {
      "name": "IDEs:",
      "values": "VS Code, Visual Studio, Android Studio, RubyMine, PyCharm, Dev-C++, Sublime3, Primavera."
    },
    {
      "name": "Programming Languages:",
      "values": "Ruby, React js"
    },
    {
      "name": "Others:",
      "values": "Docker, Shell script, Batch & System services"
    }
  ]

  return (
    <div className="container box-wrapper" style={{marginTop:"-50px", padding:"0px"}}>
      <div className="row margin-row">
        <div className="col-md-6">
          <h3 className="skill-title">Experience With Gems</h3>
          <div className="row" style={{ justifyContent: "center"}}>
            <Box sx={{ display: 'flex' }}>
              <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
                {gemsUsed.list_1.map((gemName) =>
                  <FormGroup>
                    <FormControlLabel
                      style={{ width: "max-content", fontSize: "6px"}}
                      control={
                        <Checkbox checked={gemName.length > 0 } style={{color: "#ffac3d", padding: "0px"}} name={gemName} />
                      }
                      label={gemName}
                    />
                  </FormGroup>
                )}
              </FormControl>
            </Box>

            <Box sx={{ display: 'flex' }}>
              <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
                {gemsUsed.list_2.map((gemName) =>
                  <FormGroup>
                    <FormControlLabel
                      style={{ width: "max-content"}}
                      control={
                        <Checkbox checked='true' style={{color: "#ffac3d", padding: "0px"}} name={gemName} />
                      }
                      label={gemName}
                    />
                  </FormGroup>
                )}
              </FormControl>
            </Box>
          </div>

        </div>
        <div className="col-md-6 text-left">
          {techSkills.map((techObject) =>
            <div className="tech-box">
              <span className="skill-title tech">{techObject["name"]}</span>
              <br/>
              <span className="tech-values">{techObject["values"]}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
